import { SVGProps } from "react";
import {cn} from "@/lib/utils/cn";

export const InfinityCircularLoadingIcon = (props: SVGProps<SVGSVGElement>, className?:string) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            className={cn("h-4 w-4 stroke-irGray-600 dark:stroke-white float-left ml-[1px] animate-spin-slow",className)}
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <line x1="12" y1="2" x2="12" y2="6"></line>
            <line x1="12" y1="18" x2="12" y2="22"></line>
            <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
            <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
            <line x1="2" y1="12" x2="6" y2="12"></line>
            <line x1="18" y1="12" x2="22" y2="12"></line>
            <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
            <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
        </svg>
    );
};
